import React, { memo, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import { withTranslation } from 'react-i18next';
import { keyCodes } from 'reactstrap/lib/utils';
import Attacher from './Attacher';
import {
  EMPTY_MESSAGE,
  SUPPORTED_POST_FORMATS,
} from '../../../shared/utils/constants';
import AudioRecorder from '../../../shared/components/AudioRecorder';
import SmartIconButton from '../../../shared/components/SmartIconButton';

const ChatField = ({ t, sendMessage }) => {
  const inputRef = useRef(null);
  const AUDIO_FORMATS = { mimeType: 'audio/*', description: 'audio' };
  const [messageToSend, setMessageToSend] = useState('');

  const chatFieldChangeHandler = (e) => {
    setMessageToSend(e.target.value);
  };

  const btnSendClickHandler = () => {
    const messageTrim = messageToSend.trim();
    if (messageTrim.length) {
      sendMessage(messageTrim);
      setMessageToSend('');
    }
  };

  const onChatFieldKeyUpHandler = (e) => {
    if (e.keyCode === keyCodes.enter) {
      if (e.ctrlKey) {
        setMessageToSend(`${messageToSend} \n`);
      } else if (!e.shiftKey) {
        btnSendClickHandler();
      }
    }
  };

  const onAcceptedFiles = (files) => {
    if (files.length) {
      sendMessage(EMPTY_MESSAGE, files[0]);
    }
  };

  const toggleOpenAttachment = () => {
    inputRef.current.open();
  };

  const sendRecordAudio = async (file) => {
    sendMessage(EMPTY_MESSAGE, file);
  };

  return (
    <MuiThemeProvider>
      <div className="chat__text-field">
        <Attacher
          t={t}
          ref={inputRef}
          onAcceptedFiles={onAcceptedFiles}
          acceptFiles={[AUDIO_FORMATS, ...SUPPORTED_POST_FORMATS].map(
            (format) => format.mimeType
          )}
        />
        <div className="chat__form">
          <textarea
            className="chat__field-input"
            name="chatField"
            placeholder={t('general.placeholders.type-here')}
            onChange={(e) => chatFieldChangeHandler(e)}
            onKeyUp={(e) => onChatFieldKeyUpHandler(e)}
            value={messageToSend}
            spellCheck
            lang="pt-BR"
          />
        </div>
        <div className="chat__actions">
          <SmartIconButton
            onClick={() => toggleOpenAttachment()}
            iconPath="mdiAttachment"
          />
          <AudioRecorder sendRecordAudio={sendRecordAudio} />
          <SmartIconButton onClick={btnSendClickHandler} iconPath="mdiSend" />
        </div>
      </div>
    </MuiThemeProvider>
  );
};

ChatField.propTypes = {
  t: PropTypes.func.isRequired,
  sendMessage: PropTypes.func.isRequired,
};

export default withTranslation('common')(memo(ChatField));
